import React, { useState, useEffect, useRef } from "react";
import { sbaAxios } from "../../utils/sbaAxios";
import { TopBar } from "../../shared/topBar/TopBar";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { DateRangePicker } from "rsuite";
import { getUsersLogin } from "../../../config/apiConfig";
import moment from "moment";
import download from "../../../Images/download.svg";
import { exportToExcelUsingRef } from "../../utils/excelExporter";
import { AgGridReact } from "ag-grid-react";
import { SBDateRangePicker } from "../../UiComponents/SBDateRangePicker";

export const UsersLastLogin = () => {
  const usersLastLoginRef = useRef();

  const [render, setRender] = useState(true);
  const [startDate, setStartDate] = useState(moment().subtract(30, "days"));
  const [endDate, setEndDate] = useState(moment());
  const [usersLoginData, setUsersLoginData] = useState();
    const [dateRange, setDateRange] = useState([new Date(moment().subtract(30, "days")), new Date(moment())]);
  useEffect(() => {
    document.title = `Users Last Login`;
    getUsersLoginData("", "");
    setRender(false);
  }, [render]);

  const getUsersLoginData = async (fromDate, toDate) => {
    try {
      const response = await sbaAxios({
        url: `${getUsersLogin}?&fromDate=${fromDate}&toDate=${toDate}`,
        method: "get",
      });
  
      const modifiedResponse = response.map(user => {
        const isInactive = isLastLoginInactive(user.LastLoginDate);
        return {
          ...user,
          status: isInactive ? 'Inactive' : 'Active',
        };
      });
  
      setUsersLoginData(modifiedResponse);
    } catch (error) {
      console.error("Error fetching Users Login data:", error);
    }
  };

  const isLastLoginInactive = (lastLoginDate) => {
    const lastLoginDateTime = new Date(lastLoginDate);
    const timeDifference = new Date() - lastLoginDateTime;
    return timeDifference > 20 * 60 * 1000;
  };

  const usersLastLoginColDef = [
    {
      headerName: "Name",
      field: "UserName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Email",
      field: "Email",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "IP Address",
      field: "FromIP",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Browser Info",
      field: "BrowserUsed",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Last Login Date",
      field: "LastLoginDate",
      sort: "desc",
      filter: "agTextColumnFilter",
      valueFormatter: (params) => {
        const formattedDate = moment(params.value).format("MM/DD/YYYY h:mm A");
        return formattedDate;
      },
    },
    { 
      headerName: "Status", 
      field: "status", 
      filter: "agTextColumnFilter",
      cellStyle: (params) => {
        return { color: params.value === 'Inactive' ? '#DF001B' : '' };
      },
    },
  ];

  const handleDateChange = (e) => {
      if (e) {

          const newStartDate = e.value.start !== null ? e.value.start : dateRange[0];
          const newEndDate = e.value.end !== null ? e.value.end : dateRange[1];
          setDateRange([newStartDate, newEndDate])
          setStartDate(newStartDate);
          setEndDate(newEndDate);
    }
  };

  const enterButtonClick = () => {
    getUsersLoginData(
      moment(startDate).format("YYYY-MM-DD"),
      moment(endDate).format("YYYY-MM-DD")
    );
  };

  let Level = [{ BreadCrumb: "Admin > ", Routes: `${UrlPath.Admin}` }];

  Level = render
    ? Level
    : [
        ...Level,
        {
          BreadCrumb: `Users Last Login`,
          Routes: `${UrlPath.UsersLastLogin}`,
        },
      ];

  const defaultColDef = {
    sortable: false,
    floatingFilter: true,
    flex: 1,
    resizable:true
  };

  return (
    <>
      <TopBar label={"Users Last Login"} />
      <div className="mainContentData">
        <BreadCrumbs Levels={Level} />
        <div className="container-fluid">
          <div className="bg-white p-3 border rounded">
            <div className="d-flex">
              <div className="col-md-4">
                <div className="mb-4">
                                  <span className="fw-medium">Date Range</span>
                                  <div style={{width:"70%"}}>
                                  <SBDateRangePicker
                                      value={{ start: dateRange[0], end: dateRange[1] }}
                                      onChange={(e) => { handleDateChange(e) }}

                                  />
                                  </div>
                                                    {/*<DateRangePicker*/}
                  {/*  className="SbaDateRage text-dark w-75"*/}
                  {/*  placeholder="Select Date Range"*/}
                  {/*  value={[*/}
                  {/*    startDate ? moment(startDate).toDate() : new Date(),*/}
                  {/*    endDate ? moment(endDate).toDate() : new Date(),*/}
                  {/*  ]}*/}
                  {/*  format="MM/dd/yyyy"*/}
                  {/*  block*/}
                  {/*  character=" - "*/}
                  {/*  onChange={handleDateChange}*/}
                  {/*/>*/}
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-4">
                  <button
                    className="p-sm-btn mx-1 mt-4"
                    onClick={enterButtonClick}
                  >
                    Enter
                  </button>
                </div>
              </div>
            </div>

            <div className="col-md-12 d-flex justify-content-end">
              <button
                type="button"
                className="p-sm-btn mx-1"
                onClick={() => {
                  exportToExcelUsingRef(usersLastLoginRef, "users Last Login");
                }}
              >
                <img src={download} alt="Excel" />
                Export
              </button>
            </div>

            <div className="ag-theme-alpine m-1 " style={{ height: 550 }}>
              <AgGridReact
                ref={usersLastLoginRef}
                columnDefs={usersLastLoginColDef}
                defaultColDef={defaultColDef}
                rowData={usersLoginData}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
